// Presence indicator: bright glowing neon-green dot when online, muted gray + "Offline" otherwise.
export function OnlineDot({ online, showLabel = true, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`} data-testid={`presence-${online ? "online" : "offline"}`}>
      {online ? (
        <span className="relative flex h-2.5 w-2.5">
          <span className="absolute inline-flex h-full w-full rounded-full bg-[#39ff14] opacity-70 animate-ping" />
          <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-[#39ff14] shadow-[0_0_8px_2px_rgba(57,255,20,0.9)]" />
        </span>
      ) : (
        <span className="inline-flex h-2.5 w-2.5 rounded-full bg-slate-300" />
      )}
      {showLabel && (
        <span className={`text-xs font-semibold ${online ? "text-[#1f9e0e]" : "text-slate-400"}`}>
          {online ? "Online now" : "Offline"}
        </span>
      )}
    </span>
  );
}
